import { Alert } from 'react-native';

export const formatCurrency = (amount = 0) => {
  const value = Number(amount) || 0;
  return `$${value.toFixed(2)}`;
};

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const simulateStripeCheckout = async ({ amount, description }) => {
  const niceAmount = formatCurrency(amount);

  const decision = await new Promise((resolve) => {
    Alert.alert(
      'Stripe Checkout (Sandbox)',
      `Charge ${niceAmount} for ${description}?`,
      [
        { text: 'Cancel', style: 'cancel', onPress: () => resolve('cancelled') },
        { text: 'Pay', onPress: () => resolve('paid') },
      ]
    );
  });

  if (decision !== 'paid') {
    throw new Error('PAYMENT_CANCELLED');
  }

  await wait(800);

  return {
    paymentIntentId: `pi_demo_${Date.now()}`,
    status: 'PAID',
    amountPaid: amount,
    processorFee: Number((amount * 0.029 + 0.3).toFixed(2)),
  };
};

export const calculateNetPayout = (amount = 0, processorFee = 0, platformFee = 0) =>
  Math.max(amount - processorFee - platformFee, 0);

